<template>
  <NewBsBox :bs="{ overflow: 'auto' }">
    <template
      v-for="(treeNode, idx) in menuFlatList"
      :key="idx + treeNode[idKey]"
    >
      <Divider
        v-if="idx > 0 && !treeNode.parentId"
        hair-line
        data-style="divider"
      />
      <NewBsBox
        v-show="treeNode.visible || !treeNode.parentId"
        :bs="getTreeNodeBs(treeNode)"
        :data-active="treeNode[idKey] === activeId"
        class="menu-item"
        :context="$props"
        @click="() => toggleExpand(treeNode, idx, true)"
      >
        <NewBsBox :bs="{display: 'flex', alignItems: 'center'}">
          <BeerIcon
            v-if="treeNode.icon"
            :icon="treeNode.icon"
            :bs="{cursor: 'pointer', marginRight: 8}"
            data-style="icon"
          />
          <NewBsBox
            v-if="treeNode.groupName"
            :bs="textGroupNameBs"
          >
            {{ treeNode.groupName }}
          </NewBsBox>
          <NewBsBox
            v-else
            :bs="textBs"
          >
            <slot
              :treeNode="treeNode"
              name="text"
            >
              {{ treeNode.text }}
            </slot>
          </NewBsBox>
        </NewBsBox>
        <BeerIcon
          v-if="!treeNode.isLeaf"
          :bs="getIconArrowBs(treeNode)"
          data-style="arrow"
          icon="arrow-down-m"
        />
      </NewBsBox>
    </template>
  </NewBsBox>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import Divider from '@xhs/yam-beer/cmp/common/Divider/Divider.vue'
  import { nodeType } from '@xhs/yam-beer/utils/transTree'
  import { menuItemTextBase } from './style'

  export default defineComponent({
    name: 'MenuFlatList',
    components: {
      NewBsBox,
      BeerIcon,
      Divider,
    },
    props: {
      /**
       * 处理后扁平话菜单结构
       * id,
       * text
       * groupName,
       * idPat: [...]
       * isLastItem,
       * parentId,
       * hasChild,
       * Expand,
       * visible
       * }]
       */
      menuFlatList: {
        type: Array as PropType<nodeType[]>,
        default: () => ([]),
      },
      /**
       * 菜单项右侧箭头收起/展开方法
       */
      toggleExpand: Function,
      /**
       * 菜单节点样式
       */
      getTreeNodeBs: Function,
      /**
       * 传入的list的uniq key
       */
      idKey: {
        type: String,
        default: 'id',
      },
      /**
       * primary | success | danger | warning | secondary
       * ！style文件 中使用
       */
      modifier: {
        type: String,
        default: 'primary',
      },
      /**
       * 当前页面菜单Id
       */
      activeId: {
        type: [String, Number],
        required: false,
      },
    },
    data() {
      return {
        itemHoverId: null,
      }
    },
    computed: {
      textBs() {
        return menuItemTextBase
      },
      textGroupNameBs() {
        return {
          ...menuItemTextBase,
          color: '#d9d9d9',
        }
      },
    },
    methods: {
      getIconArrowBs(treeNode: nodeType) {
        const rotateNum = treeNode.expand ? 180 : 0
        return {
          cursor: 'pointer',
          transition: 'transform 0.3s',
          transform: `rotate(${rotateNum}deg)`,
        }
      },
    },
  })
</script>
